export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || "";
export const API_PORTAL_URL = process.env.NEXT_PUBLIC_PORTAL_URL || "";
export const RAZORPAY_KEY_ID = process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID;

export const IS_DEMO =
  process.env.NEXT_PUBLIC_APP_ENV === "development" ||
  process.env.APP_ENV === "development" ||
  process.env.NODE_ENV === "development" ||
  process.env.NEXT_PUBLIC_ENABLE_SITEMAP === "false" ||
  process.env.ENABLE_SITEMAP === "false" ||
  process.env.GENERATE_SITEMAP === "false" ||
  process.env.NEXT_PUBLIC_GENERATE_SITEMAP === "false" ||
  SITE_URL.includes("novotrips") ||
  API_PORTAL_URL.includes("novotrips");

/**
 * Common configuration for international customer price hike (e.g. 15 for 15% hike).
 * Can be easily adjusted here or configured via NEXT_PUBLIC_INTERNATIONAL_PRICE_HIKE_PERCENT env variable.
 */
export const INTERNATIONAL_PRICE_HIKE_PERCENT =
  process.env.NEXT_PUBLIC_INTERNATIONAL_PRICE_HIKE_PERCENT !== undefined
    ? Number(process.env.NEXT_PUBLIC_INTERNATIONAL_PRICE_HIKE_PERCENT)
    : 15;

export default {
  API_PORTAL_URL,
  SITE_URL,
  RAZORPAY_KEY_ID,
  IS_DEMO,
  INTERNATIONAL_PRICE_HIKE_PERCENT,
};
